import { useEffect, useMemo, useState } from 'react';
import { useProfileQuery } from 'src/modules/myProfile/src/profileQueries';
import WelcomeLine from '../../../components/WelcomeLine';
import { useInvestmentNotesQuery } from '../src/investNowQueries';
import InvestNowProfile from './InvestNowProfile.jsx';
import ListNote from './ListNote';

const InvestNowDashboard = () => {
    const [page, setPage] = useState(1);
    const [themeIds, setThemeIds] = useState([]);
    const [searchString, setSearchString] = useState('');

    const { data: profileData } = useProfileQuery();

    const params = useMemo(() => ({
        'filter[theme.id][]': themeIds,
        ...(searchString ? { 'filter[name]': searchString } : {}),
    }), [themeIds, searchString]);

    const { data, isFetching } = useInvestmentNotesQuery(page, params);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [page]);

    const filterInvestmentNotes = (values, themeList) => {
        const themes = themeList
            .map((theme) => (values[theme.name + 'Filter'] ? theme.value : null))
            .filter((theme) => theme !== null)
            .sort((a, b) => a - b);

        setThemeIds(themes);
        setSearchString(values.name || '');
        setPage(1);
    };

    return (
        <div className="page-wrapper">
            <div className="dashboard-section container">
                <WelcomeLine name={profileData?.first_name || 'N/A'} />
                <div className="investNow__summary-container">
                    <InvestNowProfile />
                </div>
            </div>
            <div className="investNow__listing container">
                <ListNote
                    investmentNotes={data?.data}
                    investmentNoteCount={data?.total}
                    filterInvestmentNotes={filterInvestmentNotes}
                    isFetching={isFetching}
                    page={page}
                    setPage={setPage}
                    pageCount={data?.last_page}
                />
            </div>
        </div>
    );
};

export default InvestNowDashboard;
